<p>navdata works!</p>
<app-show-data></app-show-data>
